var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletconnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 0C21.7328 0 28 6.26719 28 14C28 21.7328 21.7328 28 14 28C6.26719 28 0 21.7328 0 14C0 6.26719 6.26719 0 14 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09681 10.3456C11.3553 7.21813 16.6447 7.21813 19.9032 10.3456L20.2955 10.7249C20.46 10.8803 20.46 11.1352 20.2955 11.2907L18.9541 12.5777C18.8719 12.6585 18.739 12.6585 18.6568 12.5777L18.119 12.0617C15.8412 9.87927 12.1588 9.87927 9.88105 12.0617L9.30528 12.615C9.22303 12.6959 9.09016 12.6959 9.00791 12.615L7.66656 11.328C7.50206 11.1725 7.50206 10.9176 7.66656 10.7622L8.09681 10.3456ZM22.6808 13.0067L23.8766 14.1508C24.0411 14.3062 24.0411 14.5611 23.8766 14.7166L18.4923 19.8834C18.3277 20.0389 18.062 20.0389 17.9038 19.8834L14.0823 16.215C14.0443 16.1777 13.9747 16.1777 13.9367 16.215L10.1152 19.8834C9.95065 20.0389 9.68491 20.0389 9.52673 19.8834L4.12338 14.7166C3.95887 14.5611 3.95887 14.3062 4.12338 14.1508L5.3192 13.0067C5.48371 12.8513 5.74945 12.8513 5.90763 13.0067L9.7292 16.6751C9.76716 16.7124 9.83676 16.7124 9.87472 16.6751L13.6963 13.0067C13.8608 12.8513 14.1265 12.8513 14.2847 13.0067L18.1063 16.6751C18.1443 16.7124 18.2139 16.7124 18.2518 16.6751L22.0734 13.0067C22.2506 12.8513 22.5163 12.8513 22.6808 13.0067Z",
    fill: "url(#paint0_radial_4544_373)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4544_373",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.00006 14.0002) scale(20 12)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D9DF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletconnect);
export default __webpack_public_path__ + "static/media/walletconnect.ddb32a2d.svg";
export { ForwardRef as ReactComponent };